export default __webpack_public_path__ + "static/media/manager.20adf750.png";